export function useEnvironmentConfig() {
  const config = useRuntimeConfig()
  const ENV = config.public.environment

  const isProd = ENV.toUpperCase() === 'PROD'
  const isStaging = ENV.toUpperCase() === 'STAGING'
  return {
    isProd,
    isStaging,
    isDev: !isProd && !isStaging,
    lowerCaseKey: ENV.toLocaleLowerCase(),
    upperCaseKey: ENV.toUpperCase(),
  }
}
